import React, { useState, useEffect } from "react";
import BreadcrumbAndHeading from "../../../components/BreadcrumbAndHeading"
import endSuction from '../../../assets/images/endSuctionSelected.jpg';
import horizontalPump from '../../../assets/images/horizontal-pump.png';
import verticalPump from '../../../assets/images/vertical-pump.png';
import CompareTable from "../../../components/CompareTable";
import LoginPopupModal from "../../../components/LoginPopupModal";
import customFetch from "../../../utils/axios";
import ToastMessage from '../../../components/ToastMessage';

const FirePumpCompare = (props) => {
    const [stocklist, setStockList] = useState([]);
    const [url, setUrl] = useState('');
    const [cart_qty, setCartQty] = useState(0);
    const [apiSuccessMessage, setApiSuccessMessage] = useState('');
    const [isLogout, setIsLogout] = useState(false);

    const stoklist =(data)=>{
        setStockList(data);
    }
    useEffect(()=>{
        if(window.innerWidth <= 768){
            setUrl('/stock-availability-mob?n='+'from_compare');         
        }else{
            setUrl('/stock-availability?n='+'from_compare');
        }
    });
    const handleQuantityChange = (value,item,rowindex) => {
        if (!isNaN(value)) {
            insertToCart(item,value);
            stocklist[rowindex].cart_qty = value;
        }

        setCartQty(values => {
            return {...values, value};
        });
    
    };
    const insertToCart= async (item,value)=>{
        try {
            if(value > 0){
                setApiSuccessMessage('');
                const formData = new FormData();
    
                formData.append("pump_id", item.id);
                formData.append("quantity", value);
                formData.append("session_id", localStorage.getItem('sessionId'));
                formData.append("avail_id", item.loc_id);
    
                const response = await customFetch.post('/add_cart',formData);
                const { status, message} = response.data;
                if (status === true) {
                    setApiSuccessMessage(message);
    
                    let cart_count = response.data.cart_count;
                    
                    document.getElementsByClassName('booking_count')[0].innerHTML = cart_count;
                }
            }
        } catch (err) {
            if (err.response.status === 401 || err.response.status === 500) {
            setIsLogout(true)
            }
            
            window.scrollTo(0,0);
        }
    }
    const setCartData =(e,loc_id,index,maxval) =>{
        const inputValue = e.target.value;
        if(parseInt(inputValue) > maxval){
            return false;
        }
        const cart_value = inputValue.replace(/\D/g, '');
        setCartQty(values => {
            return {...values, cart_value};
        });
        document.getElementsByClassName('cart_code_'+loc_id)[0].value = cart_value;
        stocklist[index].cart_qty = cart_value;

    }
    return(
        <div className="compare_product_page">
            <div className="container">
                {
                    (apiSuccessMessage) && (<ToastMessage showHidePanel={true} isError={0} message={apiSuccessMessage} />)
                }
                <div className="compare_product_block">
                    <div className="breadcrumb_verses_products">
                        <BreadcrumbAndHeading name="Performance Comparison" preUrl="Stock Booking" url={url}  />
                        <div className="verse_compare_product">
                            {stocklist.length >0 && <ul className="">
                               {stocklist.map((item, index) => ( <li>
                                    <div className="product_compare">
                                        <div className="product_item">
                                                <div className="color_text">
                                                {index=== 0 && <span className="product_color" style={{backgroundColor: "#ffc82c"}}></span>}
                                                {index=== 1 && <span className="product_color" style={{backgroundColor: "#ff8c00"}}></span>}
                                                {index=== 2 && <span className="product_color" style={{backgroundColor: "#ff0d00"}}></span>}
                                                    {/* <span className="product_name">Model : {item.model}</span> */}
                                                </div>
                                                Code ID : <span className="product_id">{item.code}</span>
                                            </div>
                                        <div className="img_qty">
                                        {/* <img src={endSuction}/> */}
                                        {item.pump_type==='End Suction' && <img src={endSuction} alt="pump selected" className="es_compare_img"/>}
                                        {item.pump_type==='Splitcase' && <img src={horizontalPump} alt="pump selected" className="hp_compare_img"/>}
                                        {(item.pump_type==='Horizontal Pump' || item.pump_type==="Vertical Turbine") && <img src={verticalPump} alt="pump selected" className="vt_compare_img"/>}
                                            <div className="compare_product_details">
                                                <div className="qty_carts">
                                                <div className="available_carts">
                                                        <input type="number" 
                                                        value={item.cart_qty}
                                                        onChange={(e)=>{ setCartData(e,item.loc_id,index,item.qty_avl)}}
                                                        pattern="\d*"
                                                         name="cart_qty" min="0" max={item.qty_avl} className={`cart_code_${item.loc_id}`} />
                            <div className='cart_icon'>                          
                            <svg onClick={(e)=>{handleQuantityChange(item.cart_qty,item,index)}} width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg" className="cart_icon">
                            <rect width="28" height="28" transform="translate(0.5)" fill="#ED1D24"/>
                            <g clipPath="url(#clip0_152_13176)">
                            <path d="M21.4192 9.92517C21.3797 9.86848 21.3276 9.82168 21.2671 9.7884C21.2065 9.75513 21.1391 9.73628 21.07 9.73333L12.3857 9.359C12.1365 9.34809 11.9283 9.54046 11.9177 9.78847C11.9071 10.0364 12.0991 10.2459 12.3471 10.2565L20.4435 10.6055L18.8516 15.5724H11.7673L10.4875 8.60363C10.4737 8.5285 10.4409 8.45813 10.3923 8.39918C10.3438 8.34023 10.281 8.29465 10.2098 8.26673L8.11364 7.44322C7.88261 7.35277 7.62191 7.46624 7.53118 7.69699C7.4406 7.92786 7.55405 8.18872 7.78495 8.27945L9.64882 9.01167L10.9513 16.1028C10.9703 16.2061 11.0249 16.2995 11.1056 16.3667C11.1864 16.434 11.2881 16.4708 11.3932 16.4708H11.6092L11.1159 17.8412C11.0955 17.8977 11.089 17.9583 11.097 18.0178C11.105 18.0773 11.1273 18.1341 11.1618 18.1832C11.1964 18.2323 11.2422 18.2724 11.2955 18.3001C11.3488 18.3278 11.408 18.3423 11.468 18.3423H11.8141C11.5996 18.5809 11.468 18.8951 11.468 19.2407C11.468 19.9838 12.0727 20.5882 12.8156 20.5882C13.5585 20.5882 14.1632 19.9838 14.1632 19.2407C14.1632 18.8952 14.0315 18.5809 13.8171 18.3423H16.7552C16.5407 18.5809 16.4091 18.8951 16.4091 19.2407C16.4091 19.9838 17.0136 20.5882 17.7567 20.5882C18.4998 20.5882 19.1042 19.9838 19.1042 19.2407C19.1042 18.8952 18.9727 18.5809 18.7583 18.3423H19.1791C19.3859 18.3423 19.5535 18.1747 19.5535 17.968C19.5535 17.7612 19.3859 17.5936 19.1791 17.5936H12.0006L12.4048 16.4707H19.1791C19.2743 16.4707 19.367 16.4405 19.4438 16.3844C19.5207 16.3283 19.5778 16.2492 19.6068 16.1586L21.4784 10.3191C21.4996 10.2533 21.5053 10.1835 21.495 10.1152C21.4847 10.0469 21.4588 9.98182 21.4192 9.92517ZM12.8156 19.8397C12.4853 19.8397 12.2167 19.5711 12.2167 19.2408C12.2167 18.9105 12.4853 18.6419 12.8156 18.6419C13.1459 18.6419 13.4145 18.9105 13.4145 19.2408C13.4145 19.5711 13.1459 19.8397 12.8156 19.8397ZM17.7567 19.8397C17.4264 19.8397 17.1578 19.5711 17.1578 19.2408C17.1578 18.9105 17.4264 18.6419 17.7567 18.6419C18.087 18.6419 18.3556 18.9105 18.3556 19.2408C18.3556 19.5711 18.087 19.8397 17.7567 19.8397Z" fill="white"/>
                            </g>
                            <defs>
                            <clipPath id="clip0_152_13176">
                            <rect width="14" height="14" fill="white" transform="translate(7.5 7)"/>
                            </clipPath>
                            </defs>
                            </svg>
                            <span className='booking_count'>{item.cart_qty}</span>
                            </div>
                                                            
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>))}
                            </ul>}
                        </div>
                    </div>       
                    <div className="table_compare">
                        <CompareTable stoklist={stoklist}/>
                    </div> 
                    <div className="toaster_popup d-none">
                        <div className="success_svg">
                            <svg width="39" height="40" viewBox="0 0 39 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect y="0.5" width="39" height="39" rx="4" fill="#039855"/>
                            <path d="M10 19.5L16 26L29 14.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                        <div className="msg_box">
                            <h5 className="msg_shows">Item added to cart</h5>
                            <h5 className="msg_shows d-none">Order Placed</h5>
                            <p className="success_shows ">Item add to cart successfully</p>
                            <p className="success_shows d-none">Your order placed successfully.</p>
                        </div>
                    </div>          
                </div>     
                <LoginPopupModal/>
            </div>
        </div>
    );
}
export default FirePumpCompare;